<template>
  <el-dialog 
    :append-to-body="true"
    :title="title"
    :visible.sync="fileUploadVisible" 
    v-if="fileUploadVisible" 
    :close-on-click-modal="false"
    :custom-class="nowOption=='iconUpload'?'dialogPaddingTop0':'fileUpload dialogPaddingTop0'">
    <el-container 
    v-if="nowOption=='import' || nowOption=='systemImport' || nowOption=='depImport'" v-loading="loading" element-loading-text="正在导入中" 
    element-loading-background="rgba(0, 0, 0, 0.5)">
      
      <p v-if="nowOption=='import' || nowOption=='depImport'"><span>附件：<a @click="installTemplate(nowOption)" style="color:#409EFF;cursor:pointer">点击下载模板</a></span></p>
      <el-upload
        class="upload-file"
        drag
        :action="getFileUrl()"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :limit="limitNum"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <el-header class="dialogBtn">
        <el-row :span="24">
          <!-- <el-col :span="9">文件上传</el-col> -->
          <el-col :span="24"  style="text-align:right">
            <span class="toolbar-buttons">
              <el-button type="primary" @click="onBack" size="small" plain>{{$t('cancel')}}</el-button>
              <el-button type="primary" @click="onSave" v-if="nowOption=='import' || nowOption=='depImport'" size="small">{{$t('confirm')}}</el-button>
              <el-button type="primary" @click="onSaveSystem" v-if="nowOption=='systemImport'" size="small">{{$t('confirm')}}</el-button>
            </span>
          </el-col>
        </el-row>
      </el-header>
    </el-container>
    
    <el-container v-if="nowOption=='iconUpload'">
      <el-header style="height:28px;"> 
        <el-row :span="24">
          <el-col :span="9">图片上传</el-col>
        </el-row>
      </el-header>
      <el-upload
        ref="upload"
        :class="nowOption=='iconUpload'?'uploadIcon':'upload-file'"
        drag
        :action="getUrl()"
        :on-success="uploadImageSuccess"
        :on-error="uploadError"
        :on-remove="removeImage"
        :data="data"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <el-row class="marginTop30 marginBot10">
          <el-col :span="24"  style="text-align:right">
            <span class="toolbar-buttons">
              <el-button type="primary" plain @click="onIconBack" size="small">{{$t('cancel')}}</el-button>
              <el-button type="primary" @click="onSaveImage" size="small">{{$t('confirm')}}</el-button>
            </span>
          </el-col>
        </el-row>
    </el-container>
    <!-- </el-main> -->
    <weixin_result :visible.sync="importResultVisible" :weixinResult="importResult" :type="mode" @exit="onBack"/>

  </el-dialog>
</template>

<script>
import weixin_result from "@/components/weixin_result.vue";

export default {
  components:{
    weixin_result,
  },
  data() {
    return {
      icons:[],
      doUpload:'/api/authtime/uploads',//文件上传增加/api
      fileData:[],
      data:{
        path:'/uploads/lib/icon/upload',
        filePath:'',
      },
      loading:false,
      limitNum:1,
      importResultVisible:false,
      importResult:{},
      mode:"file",
      title:'',
    };
  },
  
  created() {
    this.fileData=[];
    let year = new Date().getFullYear();
    this.data.filePath='/uploads/'+year;
    if(this.nowOption=='iconUpload'){
      if(this.selectOption)this.title='登录背景图片上传';
      else this.title='自定义图标上传';
    }else if(this.nowOption=='systemImport'){
      this.title= '导入';
    }else if(this.nowOption == 'depImport'){
      this.title = 'Excel部门导入'
    }else{
      this.title= 'Excel用户导入';

    }
  },
  computed: {
    fileUploadVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  props: ["visible","nowOption",'selectOption'],
  methods: {
    installTemplate(tabName){
      let name = '';
      tabName == "depImport" ? name = "部门" : name = "用户"
      this.$api.installTemplate(name)
    },
    importData(){
      this.fileUploadVisible=true;
      
    },
    upSuccess(){
      
    },
    newSubmitForm(){//确定上传
        this.$refs.newupload.submit();
    },
    uploadSuccess(res){
      this.fileData=res.data;
    },
    uploadImageSuccess(res){
      if(res.errcode==0){
        let preIconsUp=[...this.fileData]
        this.fileData=[...preIconsUp,...res.data];

      }else{
        this.$message({
          showClose: true,
          message: res.errmsg,
          type: "error"
        });
        this.$refs.upload.clearFiles();
      }

    },
    uploadError(err){
      alert("上传失败"+err)
    },
    removeImage(file){
      let delIcon=[];
      file.response.data.forEach(elm=>{
        delIcon.push(elm.filePath);
      })
      this.$emit("del", delIcon);
    },
    onSave(){
      let that= this;
      if(!this.fileData || !this.fileData[0]){
        this.$message({
          showClose: true,
          message: "请上传文件!",
          type: "error"
        });
        return false;
      }
      this.loading=true;
      if(this.nowOption == 'import'){
        this.$api.importUser(this.$route.query.domainid,{path:this.fileData[0].filePath}, {
          onSucess: resp => {
            if (resp && resp.data.errcode == 0) {
              that.importResult={
                "DEPT_ADD_FAIL":resp.data.data.general.DEPT_ADD_FAIL,
                "DEPT_ADD_SUCCESS":resp.data.data.general.DEPT_ADD_SUCCESS,
                "USER_ADD_FAIL":resp.data.data.general.USER_ADD_FAIL,
                "USER_ADD_SUCCESS":resp.data.data.general.USER_ADD_SUCCESS,
                "ERRORS":resp.data.data.detail
              }
              that.loading=false;
              that.onExit();
            } else {
              this.$message({
                message: resp.data.errmsg,
                type: "error"
              });
              this.loading=false;
            }
          }
        });
      }else{
        this.$api.departmentImport(this.$route.query.domainid, this.fileData[0].filePath,
          {
            onSucess: resp => {
              if (resp && resp.data.data ) {
                this.$message({
                  message: resp.data.data,
                  type: "error"
                });
              } else {
                this.$message({
                  message: '导入成功',
                  type: 'success'
                });
                that.$emit("success")
                that.fileUploadVisible = false;
              }
              this.loading=false;
            }
          }
        )
      }

    },
    onSaveImage(){
      this.fileUploadVisible=false;
      this.$emit("checkUpload", this.fileData);
    },
    onSaveSystem(){
      let that=this;
      this.$api.importConfig({path:this.fileData[0].filePath}, {
        onSucess: resp => {
          if (resp && resp.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: "导入成功!",
              type: "success"
            });
            that.loading=false;
            that.$emit("success")
            that.onBack();

          } else {
            this.$message({
              message: resp.data.errmsg,
              type: "error"
            });
            this.loading=false;

          }
        }
      });
    },
    onBack(){
      this.fileUploadVisible=false;
      this.$emit("success")
    },
    onIconBack(){
      let delIcon=[];
      this.fileData.forEach(elm=>{
        delIcon.push(elm.filePath);
      })
      if(delIcon.length>0)
      this.$emit("del", delIcon);      
      this.fileUploadVisible=false;

    },
    onExit(){
      this.importResultVisible=true;
    },
    getUrl(){
      return this.$api.getLogoUrl(this.doUpload+"?path="+this.data.path+"&icon=true")
    },
    getFileUrl(){
      return this.$api.getLogoUrl(this.doUpload+"?path="+this.data.filePath+"&icon=false")
    }
    
  }
};
</script>

<style lang="scss" scoped>
</style>